import { http } from '../../helpers/http.helper';
import { ApiResource } from '../../models/api-resource.interface';
import { ApiPatch } from './../../models/api-patch.interface';
import { UserInfo } from './user-info.interface';

export class UserInfoService {
   async getUserInfo() {
      const response = await http.get<ApiResource<UserInfo>>(`/user-info`);
      return response.data?.data;
   }

   async patchUserInfo(userInfoPatchData: ApiPatch) {
      const response = await http.patch<ApiResource<UserInfo>>(`/user-info`, userInfoPatchData);
      return response.data?.data;
   }
}
